import { colors } from "@styles/colors";

export const Ic = ({ d, c = colors.gray, s = 20, sw = 1.5 }: { d: string; c?: string; s?: number; sw?: number }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" fill="none">
    <path d={d} stroke={c} strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Ar = ({ c = colors.gray200, s = 16 }: { c?: string; s?: number }) => (
  <svg width={s} height={s} viewBox="0 0 20 20" fill="none">
    <path d="M8 4l6 6-6 6" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Star = ({ s = 11 }: { s?: number }) => (
  <svg width={s} height={s} viewBox="0 0 24 24">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14l-5-4.87 6.91-1.01z" fill={colors.amber} />
  </svg>
);

export const TankIcon = ({ c = "#fff", s = 20 }: { c?: string; s?: number }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" fill="none">
    <rect x="6" y="7" width="12" height="14" rx="3" stroke={c} strokeWidth="1.5" />
    <ellipse cx="12" cy="7" rx="5" ry="1.8" stroke={c} strokeWidth="1.5" />
    <rect x="10.5" y="2" width="3" height="5" rx="1.5" stroke={c} strokeWidth="1.2" />
  </svg>
);
